import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get_api } from '../../../../redux/api_funcs';
import * as actions from '../../../../redux/action_creators';
import { get_api_url } from '../../../../utils/urls';
import CommonHeader from '../../../util_components/common_header';
import CustomSelect from '../../../util_components/custom_single_select';
import { inactive_past_inactive_status } from '../../../../constants';

// goserver encodes every time.Time on this payload as RFC3339 in UTC (`2026-10-01T00:00:00Z`): its
// MySQL DSN sets loc=UTC (app/core/mysql.go) and main.go sets time.Local = time.UTC. The first ten
// characters are therefore the UTC calendar date, which is what the old split(' ') meant to show
// before the format stopped containing a space. The optional call keeps the nullable
// active_date and inactive_date (*time.Time) safe.
const date_part = (value) => value?.slice(0, 10);

class InactiveMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      inactiveMembersDetails: [],
      isInfoButtonClicked: null,
      inactive_status: inactive_past_inactive_status[0].value,
      btn_name: inactive_past_inactive_status[0].label,
      total_number_of_member: 0,
      iana_abbr_list: [],
      selected_iana_timezone: 'ALL'
    };

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.loadData();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    // wrapperRef is attached only to the info cell of the row whose popup is open, so it is null
    // whenever no popup is open (including an empty list, where this used to throw).
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ isInfoButtonClicked: null });
    }
  }

  loadData = () =>
    this.setState({ loading: true }, () => {
      const { inactive_status } = this.state;
      try {
        const path = `/v2/campaign/utility/ten_days_inactive_users?${inactive_status}`;
        const url = get_api_url(path, false, true);
        get_api(url, true)
          .then((res) => {
            this.setState({
              loading: false,
              inactiveMembersDetails: res.data.data.inactive_users,
              total_number_of_member: res.data.data.inactive_users,
              iana_abbr_list: [...res.data.data.iana_timezone_abbr]
            });
          })
          // Copied from reports/payment_failures/index.jsx. The try/catch around this call only
          // sees synchronous throws, so without this a failed request left the loader on forever.
          // The previous list stays as it was: emptying it would read as "nobody is inactive".
          .catch((e) => {
            let message;
            try {
              message = e.response.data.message;
            } catch (err) {
              message = 'Some error occured. Please contact dev team.';
            }
            if (typeof message !== 'string')
              message = 'Some error occured. Please contact dev team.';
            this.props.set_notification_variable(true, 'error', message);
            this.setState({ loading: false });
          });
      } catch (e) {
        this.setState({ loading: false });
        console.log(e);
      }
    });

  openInfo = (index) => {
    if (index === this.state.isInfoButtonClicked) {
      this.setState({ isInfoButtonClicked: null });
    } else {
      this.setState({ isInfoButtonClicked: index });
    }
  };

  renderInfo = (data, last_inactive_date) => (
    <div
      className="bg-white rounded-xl border-2 border-borderColor z-10 top-1 left-5 p-4 absolute w-max flex flex-col items-start"
      onClick={(e) => e.stopPropagation()}
    >
      {/* goserver fills this with append(nil, rows...), which stays nil and encodes as null for a
          student with no history rows. */}
      {(data.inactive_history.inactive_history_details || []).map((data) => (
        <>
          <div>Active - {date_part(data.active_date)}</div>
          <div className="mt-2 mb-2">
            {data.inactive_date ? `Inactive - ${date_part(data.inactive_date)}` : ''}
          </div>
        </>
      ))}

      <div>Last Inactive Date - {last_inactive_date}</div>
      <div className="mt-2">
        No. of times became inactive - {data.inactive_history.inactive_frequency}
      </div>
    </div>
  );

  change_status = (value, label) => {
    this.setState(
      {
        inactive_status: value,
        btn_name: label,
        selected_iana_timezone: 'ALL'
      },
      () => {
        this.loadData();
      }
    );
  };

  change_iana_timezone = (e) => {
    this.setState({ selected_iana_timezone: e.target.value });
  };

  clear_timezone = () => this.setState({ selected_iana_timezone: 'ALL' });

  render_filter = () => {
    const { iana_abbr_list, selected_iana_timezone } = this.state;
    return (
      <div className="flex items-center justify-center">
        <div style={{ marginRight: '10px' }}>
          <CustomSelect
            label="Select a timezone"
            options={iana_abbr_list}
            onChange={this.change_iana_timezone}
            value={selected_iana_timezone}
            style={{ width: '200px' }}
            showClear
            clear_fn={this.clear_timezone}
          />
        </div>
      </div>
    );
  };

  render_status_btn = () => {
    const { inactive_status } = this.state;
    return inactive_past_inactive_status.map((item, index) => (
      <button
        key={index}
        className={`${item.value === inactive_status ? 'btn-white-icon bg-mytBlue text-white' : 'btn-white-icon'}`}
        onClick={() => this.change_status(item.value, item.label)}
      >
        {item.label}
      </button>
    ));
  };

  studentDetails = () => {
    const tableHeader = [
      'Name',
      'Active/Inactive History',
      'info',
      'Membership Date',
      'Membership Plan',
      'Last Class Date',
      'Total Classes Till Date',
      'Weeks Active %',
      'Pause %',
      'Links to Open SMS and Chat with Member'
    ];

    return (
      <div className="cus-table">
        <div className="ct-row ct-h">
          {tableHeader.map((headers) => (
            <div className="ct-col ct-sm-font">{headers}</div>
          ))}
        </div>
        {this.renderSingleMembers()}
      </div>
    );
  };

  renderSingleMembers = () => {
    const { selected_iana_timezone, iana_abbr_list } = this.state;
    let filter_students = this.state.inactiveMembersDetails;
    if (!!selected_iana_timezone && selected_iana_timezone !== 'ALL') {
      const timezone = iana_abbr_list.find((item) => item.label === selected_iana_timezone);
      if (timezone) {
        filter_students = filter_students.filter((s) => s.iana_timezone_abbr === timezone.value);
      }
    }
    return (
      <div className="flex flex-col items-stretch">
        {filter_students?.map((data, index) => {
          const last_inactive_date = date_part(data.inactive_history.last_inactive_date);
          const membership_start_date = date_part(data.membership_details.membership_start_date);
          const last_class_date = date_part(data.last_class_date);
          return (
            <div key={index} className="ct-row flex">
              <div className="ct-col ct-sm-font flex flex-col break-all">
                <div>{data.student_name}</div>
                <div>{data.student_email}</div>
              </div>
              <div className="flex-row ct-col ct-sm-font flex break-all">
                <div>Last Inactive - {last_inactive_date}</div>
              </div>
              <div>
                <div
                  ref={this.state.isInfoButtonClicked === index ? this.wrapperRef : null}
                  className="ct-col ct-sm-font cursor-pointer flex items-center justify-center"
                  onClick={(e) => this.openInfo(index)}
                >
                  <div className="relative ct-si">
                    <img
                      src="https://images.myyogateacher.com/icons/ic_info_blue.png"
                      alt="Show inactive history"
                    />
                    {this.state.isInfoButtonClicked === index &&
                      this.renderInfo(data, last_inactive_date)}
                  </div>
                </div>
              </div>
              <div className="ct-col ct-sm-font flex flex-col break-all">
                <div>Member Date - {membership_start_date}</div>
                <div>Member Months - {data.membership_details.membership_month}</div>
              </div>
              <div className="ct-col ct-sm-font flex justify-center item-center">
                {data.membership_details.package_name}
              </div>
              <div className="ct-col ct-sm-font">{last_class_date}</div>
              <div className="ct-col ct-sm-font flex flex-col break-all">
                <div>1on1 - {data.session_finished_stats.yoga}</div>
                <div>Group Class - {data.session_finished_stats.gc}</div>
              </div>
              <div className="ct-col ct-sm-font ">{data.active_weeks}%</div>
              <div className="ct-col ct-sm-font ">{data.pause_percentage}%</div>
              <div className="ct-col ct-sm-font flex flex-col gap-2">
                {/* {
                                        data.zendesk_profile !== "" ?
                                            <a className='btn-link' target='_blank' href={data.zendesk_profile}>Zendesk profile</a>
                                            :
                                            'NA'
                                    } */}
                {data.zendesk_profile !== '' ? (
                  <a
                    className="btn-link"
                    target="_blank"
                    href={data.student_profile}
                    rel="noreferrer"
                  >
                    Student profile
                  </a>
                ) : (
                  'NA'
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { loading, btn_name, total_number_of_member } = this.state;
    return (
      <div>
        <CommonHeader className="width-full" loading={loading} title={`${btn_name} Members`}>
          <>
            <div className="flex justify-center text-3xl font-bold ">
              {total_number_of_member?.length}
            </div>
            <div className="mb-2 items-center flex">{this.render_status_btn()}</div>
            <div>{this.render_filter()}</div>
            {this.studentDetails()}
          </>
        </CommonHeader>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(null, mapDispatchToProps)(InactiveMembers);
